import { render, staticRenderFns } from "./SmartTag.vue?vue&type=template&id=27636099&scoped=true"
import script from "./SmartTag.vue?vue&type=script&lang=js"
export * from "./SmartTag.vue?vue&type=script&lang=js"
import style0 from "./SmartTag.vue?vue&type=style&index=0&id=27636099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27636099",
  null
  
)

export default component.exports